import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartClientTabPure extends React.Component {
  render() {
    const { data } = this.props;

    let pivots = ["tiersClient", "category", "tiers"];
    let showColumns = ["tiersClient", "category", "tiers"];

    if (
      this.props.showProductColumn === undefined ||
      this.props.showProductColumn === true
    ) {
      //show product by default
      pivots.push("product");
      showColumns.push("product");
    }
    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "tiersClient") + computeDefaultTableSize(data, "tiers")}
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={true}
        showExtra={true}
        defaultSorted={[
          {
            id: "tiersClient",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartClientTabPure;
